import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const gRadioCss = ".g__radio{box-sizing:border-box;display:inline-block;margin-right:1rem}.g__radio__label{font-weight:500;display:inline-block;padding:0.5em 0 0.5em 1.5em;position:relative}.g__radio__label::before{content:\"\";display:inline-block;vertical-align:middle;width:1.15em;height:1.15em;border:2px solid #737373;margin-right:0.5em;background-color:#fff;background-repeat:no-repeat;background-position:50%;background-size:75%;border-radius:50%;position:absolute;top:0.65em;left:0;}input[type=radio]:checked+.g__radio__label::before{background-image:url(\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2MCA0OC43NSI+PHBhdGggZD0iTTQ5LjI4IDBMMjEgMjcuNzlsLTEwLjQ4LTEwLjNMMCAyOC4wMWwyMSAyMC43NCAzOS0zOC41MXoiLz48L3N2Zz4=\");border-color:#000}.g__radio input{position:absolute;overflow:hidden;clip:rect(0 0 0 0);height:1px;width:1px;margin:-1px;padding:0;border:0}.g__radio input:focus+.g__radio__label::before{box-shadow:0 0 0.5em 0 rgba(0, 0, 0, 0.4);border-color:#000}.g__radio input:disabled,.g__radio input:disabled+.g__radio__label{opacity:0.5}.g__radio input:disabled+.g__radio__label:hover{cursor:not-allowed}";
const GRadioStyle0 = gRadioCss;

const GRadio$1 = /*@__PURE__*/ proxyCustomElement(class GRadio extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.label = undefined;
        this.dataTestId = undefined;
    }
    componentWillRender() {
        if (!this.label) {
            /* eslint-disable */
            console.error('No label attribute set on g-radio component');
        }
    }
    render() {
        var _a, _b;
        const baseClass = 'g__radio';
        const componentClasses = {
            [baseClass]: true,
        };
        /* eslint-disable jsx-a11y/label-has-associated-control */
        /* Input will be passed in via slot and nested within the label */
        return (h(Host, { key: '0b5e36880e9f1f975b5478c1586191bb3b3cc2a5', class: componentClasses, "data-testid": ((_a = this.dataTestId) === null || _a === void 0 ? void 0 : _a.host) || baseClass }, h("label", { key: '663ba167991a0df108eb7e076d83fc0c5eb83176' }, h("slot", { key: '54476eb1eb12a258f1dde6cfc2ddfad0f880b57c' }), h("span", { key: '96124e1d8b0f1edea2637dc6d9c037103064cfa7', class: "g__radio__label", "data-testid": (_b = this.dataTestId) === null || _b === void 0 ? void 0 : _b.labelText }, this.label))));
    }
    static get style() { return GRadioStyle0; }
}, [4, "g-radio", {
        "label": [1],
        "dataTestId": [16]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["g-radio"];
    components.forEach(tagName => { switch (tagName) {
        case "g-radio":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, GRadio$1);
            }
            break;
    } });
}

const GRadio = GRadio$1;
const defineCustomElement = defineCustomElement$1;

export { GRadio, defineCustomElement };

//# sourceMappingURL=g-radio.js.map